<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <div class="avatar-container" style="margin-right: 50px">
        <div class="avatar-wrapper">
          <el-badge :value="counts" class="custom-badge" :hidden="counts === 0">
            <img class="user-avatar" :src="remind" style="background-color: #409EFF" @click="toMessageBoard">
          </el-badge>
        </div>
    </div>

    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" :src="avatar">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import remind from '@/assets/images/remind.png';
import { getUnreadMsgCount } from '@/api/messageBoard';

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    return {
      timer: null,
      remind
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'counts'
    ])
  },
  mounted() {
    this.startAPIFetchInterval();
  },
  beforeDestroy() {
    this.stopAPIFetchInterval();
  },
  methods: {
    toMessageBoard(){
      this.$router.push({path: '/ums/messageBoard'})
    },
    startAPIFetchInterval() {
      this.timer = setInterval(() => {
        this.fetchUnreadMsgCount();
      }, 30 * 1000);
    },
    stopAPIFetchInterval() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    fetchUnreadMsgCount(){
      getUnreadMsgCount().then(response => {
        this.$store.commit('SET_COUNTS', response.data);
      })
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 60px;
  line-height: 50px;
  border-radius: 0px !important;
  margin-top: 10px;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}

//.navbar .avatar-container .avatar-wrapper .custom-badge ::v-deep .el-badge__content {
//  top: 6px;
//  right: 15px;
//}

.el-badge {
  ::v-deep .el-badge__content {
    top: 6px;
    right: 15px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue